var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0 pb-0",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('iframe',{ref:"container"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }